import Header from '../Header/Header'
import React from 'react'
import Footer from '../Footer/Footer'

function KnowledgeBase () {
  const backgroundImageUrl = '/assets/images/banners/13.png'

  return (
    <>
      <Header />
      <main className='tw-bg-slate-50 lg:tw-pt-20'>
        <section className='tw-py-0 tw-pt-20'>
          <div className='tw-container tw-mx-auto xl:tw-max-w-7xl tw-px-4'>
            <div className='tw-text-left tw-mb-12'>
              <h2 className='tw-text-2xl md:tw-text-3xl xl:tw-text-4xl tw-font-bold tw-text-slate-900 tw-leading-tight tw-max-w-4xl'>
                Kompletna baza wiedzy w formie e-booka – wszystko, co musisz wiedzieć o Kreatlo
              </h2>
              <p className='tw-mt-4 tw-text-sm md:tw-text-base xl:tw-text-lg tw-text-slate-600 tw-max-w-3xl'>
                Aby maksymalnie ułatwić Ci pracę z naszą platformą, przygotowaliśmy kompleksowy e-book w formacie PDF, który stanowi uporządkowaną bazę wiedzy na temat wszystkich funkcji aplikacji. To praktyczny przewodnik, dzięki któremu krok po kroku poznasz możliwości narzędzia i wykorzystasz jego potencjał w codziennej pracy projektowej.
              </p>
            </div>
          </div>

          <div className=''>
            <img
              src={backgroundImageUrl}
              alt='E-book Kreatlo'
              className='tw-w-full tw-h-auto tw-shadow-2xl'
            />
          </div>
        </section>

        <ContentSection
          eyebrow='E-book'
          title='Ten przewodnik jest idealny zarówno dla nowych użytkowników, którzy chcą szybko zacząć pracę z platformą, jak i dla bardziej zaawansowanych, którzy szukają konkretnych rozwiązań lub chcą jeszcze efektywniej wykorzystywać narzędzie.'
          leftColumnContent={[
            { type: 'paragraph', content: 'Rozwijamy Kreatlo dynamicznie, słuchając potrzeb projektantów i architektów. Dlatego każda nowa funkcja, aktualizacja czy ulepszenie jest dokładnie opisane i komunikowane użytkownikom.' },
            { type: 'paragraph', content: 'Regularnie otrzymasz:' },
            {
              type: 'list',
              items: [
                'powiadomienia mailowe z nowościami i praktycznymi przykładami zastosowania nowych narzędzi',
                'aktualizacje e-booka PDF, które możesz pobrać w każdej chwili',
                'dostęp do najnowszych materiałów bezpośrednio z poziomu aplikacji'
              ]
            }
          ]}
          rightColumnContent={
            <p className='tw-text-slate-600 tw-leading-relaxed'>
              Z nami nie musisz niczego szukać na własną rękę. Wszystko, co nowe i istotne, trafia do Ciebie automatycznie — przejrzyście, konkretnie i z myślą o Twoim czasie.
            </p>
                    }
          buttonText='Pobierz e-book'
          buttonLink='https://www.youtube.com/@kreatlo-25'
        />

        <ContentSection
          eyebrow='Nasz kanał na Youtube'
          title='Zajrzyj na nasz kanał YouTube i przekonaj się, jak intuicyjnie możesz zarządzać projektami z Kreatlo. Bo dobra wiedza to taka, którą łatwo zrozumieć i od razu wykorzystać.'
          leftColumnContent={[
            { type: 'paragraph', content: 'Dla wszystkich, którzy wolą zobaczyć niż przeczytać – stworzyliśmy dedykowany kanał YouTube Kreatlo, na którym w przystępny sposób prezentujemy działanie poszczególnych funkcji naszej platformy. Znajdziesz tam: krótkie, konkretne wideoporadniki krok po kroku każdej funkcji.' },
            { type: 'paragraph', content: 'Nasze filmy są tworzone z myślą o oszczędności Twojego czasu – bez zbędnej teorii, prosto do rzeczy. Dzięki nim łatwiej i szybciej wdrożysz się w obsługę platformy, a nowe funkcje staną się od razu użyteczne w praktyce.' }
          ]}
          rightColumnContent={
            <p className='tw-text-slate-600 tw-leading-relaxed tw-whitespace-pre-line'>
              Nowe funkcje? Nowe filmy!{'\n\n'}
              Każda nowa funkcjonalność to także nowy materiał wideo – tak, abyś nie musiał zgadywać, do czego służy dana opcja i jak ją zastosować. Subskrybując kanał, masz pewność, że:{'\n\n'}
              - jesteś zawsze na bieżąco z rozwojem platformy{'\n'}
              - otrzymujesz jasne instrukcje w formie wideo{'\n'}
              - możesz w dowolnej chwili wrócić do materiałów, kiedy tego potrzebujesz
            </p>
                    }
          buttonText='Odwiedź kanał YouTube'
          buttonLink='https://www.youtube.com/@kreatlo-25'
          reverse
        />

        <section className='tw-bg-white tw-py-12 md:tw-py-16'>
          <div className='tw-container tw-mx-auto xl:tw-max-w-7xl tw-py-0 tw-px-6 tw-text-center'>
            <h4 className='tw-text-lg md:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-slate-800 tw-mb-3'>
              Chcesz wiedzieć więcej?
            </h4>
            <p className='tw-text-xs md:tw-text-sm xl:tw-text-base tw-text-slate-600 tw-max-w-xl tw-mx-auto'>
              Potrzebujesz więcej informacji na temat konkretnej funkcji?
              <br />
              Skontaktuj się z pomocą techniczną, wyślij do nas maila
            </p>
            <a
              href='mailto:help@kreatlo.com'
              className='tw-mt-4 tw-inline-block tw-text-lg tw-font-semibold
                                    tw-text-teal hover:tw-text-teal/40 hover:tw-underline
                                    tw-transition-colors'
            >
              help@kreatlo.com
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

type ContentItem =
    | { type: 'paragraph', content: string }
    | { type: 'list', items: string[] }

interface ContentSectionProps {
  eyebrow?: string
  title: string
  leftColumnContent: ContentItem[]
  rightColumnContent: React.ReactNode
  buttonText?: string
  buttonLink?: string
  reverse?: boolean
}

const ContentSection: React.FC<ContentSectionProps> = ({
  eyebrow,
  title,
  leftColumnContent,
  rightColumnContent,
  buttonText,
  buttonLink,
  reverse = false
}) => {
  return (
    <section className='tw-bg-white tw-py-16 md:tw-py-24'>
      <div className='tw-container tw-mx-auto tw-px-6'>
        <div>
          {eyebrow && (
            <div className='tw-flex tw-items-center tw-mb-3'>
              <span className='tw-w-10 tw-h-1 tw-bg-green-600 tw-mr-4' />
              <p className='tw-font-semibold tw-text-green-600'>{eyebrow}</p>
            </div>
          )}
          <h3 className='tw-text-3xl md:tw-text-4xl tw-font-bold tw-text-slate-900 tw-leading-tight tw-max-w-5xl'>
            {title}
          </h3>
        </div>

        <div className={`tw-mt-10 tw-flex tw-flex-col tw-gap-8 md:tw-gap-12 ${reverse ? 'md:tw-flex-row-reverse' : 'md:tw-flex-row'}`}>
          <div className='md:tw-w-1/2'>
            {leftColumnContent.map((item, index) => {
              if (item.type === 'list') {
                return (
                  <ul key={index} className='tw-list-disc tw-list-inside tw-mt-4 tw-space-y-2 tw-text-slate-600 tw-leading-relaxed'>
                    {item.items.map((listItem, liIndex) => (
                      <li key={liIndex}>{listItem}</li>
                    ))}
                  </ul>
                )
              }
              return (
                <p key={index} className={`tw-text-slate-600 tw-leading-relaxed ${index > 0 ? 'tw-mt-4' : ''}`}>
                  {item.content}
                </p>
              )
            })}
          </div>

          <div className='md:tw-w-1/2'>
            {rightColumnContent}
            {buttonText && buttonLink && (
              <a
                href={buttonLink}
                target='_blank'
                rel='noopener noreferrer'
                className='tw-mt-8 tw-inline-block tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 hover:tw-text-white focus:tw-bg-green'
              >
                {buttonText}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default KnowledgeBase
